import React from "react";
import "../styles/home.css";
import Navbar from "../components/BlogNavbar";
import Career from "../components/career";

const Home = () => {
  return (
    <div className="home">
      <Navbar />
      <Career />
    </div>
  );
};

export default Home;
